export default __webpack_public_path__ + "static/media/ico-warning.22fccd49.svg";